import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { PurchaseOrderItem } from '../PurchaseOrderItem'
import { Vendor } from '../../vendor/Vendor'

@InputType()
export class UpdatePurchaseOrderVendorCodeAndPriceArgs extends ActionArgs {
  @Field(() => PurchaseOrderItem)
  purchaseOrderItem: PurchaseOrderItem

  @Field(() => Vendor)
  vendor: Vendor

  @Field(() => String)
  purchaseOrderId: string
}
